import '@creilsudoise/scss/app-front-page.scss';
import Utils from '@creilsudoise/js/services/utils';
import Slider from '@creilsudoise/js/services/slider';
import Single from '@creilsudoise/js/wpet/single';
import Form from '@creilsudoise/js/services/form';
import Menu from '@creilsudoise/js/services/Menu';
import Modernizr from 'modernizr';
import fullpage from 'fullpage.js';

document.addEventListener( "DOMContentLoaded", function () {

    // Utils
    Utils.click();
    // Utils.disable_right_click();
    Utils.bootstrap();
    Utils.searchbox();
    Utils.smooth_scroll();
    Utils.lazy();
    Utils.obfuscation();
    Utils.progress_bar();

    // Slider
    Slider.hero();
    Slider.thematiques_home();

    // Specific
    console.log('front-page');
    Form.footer_newsletter();

    // Menu
    Menu.burger();
    Menu.scroll_header_large();

    //Anchors
    // Single.get_id_active();
    // Single.anchor_navigation($( '[data-id="anchor"]' ), $( '[data-trigger="anchor-item"]' ),  $( '[data-id="strate"]' ));

    if( $( '.fullpage' ).length > 0 && window.matchMedia( "(min-width:1000px)" ).matches ) {
        new fullpage('.fullpage', {
            //options here
            licenseKey: Theme.fullpage_key,
            autoScrolling:true,
            anchors: [
                "header",
                "famille",
                "amis",
                "couple",
                "groupe",
                "incontournables",
                "evenements",
                "instagram",
            ],
            menu: '.anchorsList'
        });
    }
})
